import React from 'react'

export default function ArrowLeftClick() {
  return (
    <svg
      width="10"
      height="13"
      viewBox="0 0 10 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 2L3 6.58333L8 11.1667"
        stroke="#3249D7"
        strokeWidth="3"
        strokeLinecap="round"
      />
    </svg>
  )
}
